export enum NotesActionEnum {
  DO_NOT_CHANGE = 'DO_NOT_CHANGE',
  CLEAR = 'CLEAR',
  REPLACE = 'REPLACE',
}
